import { render, staticRenderFns } from "./DesignBulletinAnalyseReportList.vue?vue&type=template&id=3584e6d3&"
import script from "./DesignBulletinAnalyseReportList.vue?vue&type=script&lang=js&"
export * from "./DesignBulletinAnalyseReportList.vue?vue&type=script&lang=js&"
import style0 from "./DesignBulletinAnalyseReportList.vue?vue&type=style&index=0&id=3584e6d3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports